import React, { useState } from 'react';
import { MdList, MdAttachMoney } from 'react-icons/md';
import { VscSearch } from 'react-icons/vsc';
import { GiPayMoney } from 'react-icons/gi';
import { SiMicrosoftexcel } from 'react-icons/si';
import { Outlet } from 'react-router-dom';
import Header from '../../../layouts/Header';
import Filter from '../../../helpers/filter/Filter';
import HeaderNavButton from '../../../helpers/buttons/HeaderNavButton';

export default function Payrolls() {
  const [filterValue, setFilterValue] = useState('');

  const navButtons = [
    { to: 'outstanding', icon: MdList, label: 'Outstanding Payrolls' },
    { to: 'search', icon: VscSearch, label: 'Search Payrolls' },
    { to: 'paylocity', icon: SiMicrosoftexcel, label: 'Paylocity' },
    { to: 'apply-payments', icon: GiPayMoney, label: 'Apply Payments' },
    { to: 'payments', icon: MdAttachMoney, label: 'View Payments' },
  ];

  return (
    <>
      <h1>Payrolls</h1>
      <Header>
        <div>
          {navButtons.map(button => (
            <HeaderNavButton
              key={button.to}
              to={button.to}
              icon={button.icon}
              label={button.label}
            />
          ))}
        </div>
        <div>
          <Filter
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            placeholder="Filter payrolls"
          />
        </div>
      </Header>
      <Outlet context={filterValue} />
    </>
  );
}
